import { languageQuery, getFeatureEnabled, FeatureEnabledV2, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __assign, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { Feature } from '@gig/magic-messages';
import { ConsentName } from '@gig/magic-sdk/dist/adapter/users/userPendingConsents';
import { EGroupCheckboxState, calculateConsentGroupState, getConsentGroup, interpolateConsent, MINIMUM_AGE } from '@gig/magic-account-types';
import { SIGN_UP_NAMESPACE } from '../../store/modules/sign-up/sign-up.constants.js';
import '../../store/modules/sign-up/sign-up.store.js';
import { store } from '../../store/index.js';
import { namespace } from 'vuex-class';

var signUpModule = namespace(SIGN_UP_NAMESPACE);
/**
 * Component to display the marketing components in the sign up.
 */
var SignUpConsentsComponent = /** @class */ (function (_super) {
    __extends(SignUpConsentsComponent, _super);
    function SignUpConsentsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         *  * Whether merged terms is enabled
         */
        _this.isRegistrationMergedTermsEnabled = false;
        _this.consentTouched = {};
        return _this;
    }
    SignUpConsentsComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var language, consents;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.formModel.userConsents) return [3 /*break*/, 3];
                        return [4 /*yield*/, languageQuery()];
                    case 1:
                        language = _a.sent();
                        return [4 /*yield*/, this.fetchConsents(language)];
                    case 2:
                        consents = _a.sent();
                        this.emitStandAloneChange(consents, false);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SignUpConsentsComponent.prototype, "groupedConsents", {
        get: function () {
            if (!this.valueObject) {
                return {};
            }
            return this.splitTermsAndMarketingConsents(this.valueObject);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignUpConsentsComponent.prototype, "termsConsents", {
        get: function () {
            var _a;
            return ((_a = this.groupedConsents) === null || _a === void 0 ? void 0 : _a.terms) || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignUpConsentsComponent.prototype, "marketingConsents", {
        get: function () {
            var _a;
            return ((_a = this.groupedConsents) === null || _a === void 0 ? void 0 : _a.marketing) || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignUpConsentsComponent.prototype, "isTermsGroupChecked", {
        get: function () {
            return this.termsGroupState === EGroupCheckboxState.CHECKED;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignUpConsentsComponent.prototype, "isTermsGroupIndeterminate", {
        get: function () {
            return this.termsGroupState === EGroupCheckboxState.INDETERMINATE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignUpConsentsComponent.prototype, "termsGroupState", {
        get: function () {
            return calculateConsentGroupState(this.termsConsents);
        },
        enumerable: false,
        configurable: true
    });
    SignUpConsentsComponent.prototype.fetchConsents = function (lang) {
        return __awaiter(this, void 0, void 0, function () {
            var slugPrivacy, slugTerms, _a, privacyPageRes, termsPageRes, privacyPage, termsPage, consents, isPromotionalOffersEnabled;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        slugPrivacy = 'keycloak-privacy-cookie-policy';
                        slugTerms = 'keycloak-tnc';
                        return [4 /*yield*/, Promise.all([
                                magic.methods.pages.get({ slug: slugPrivacy, lang: lang }),
                                magic.methods.pages.get({ slug: slugTerms, lang: lang }),
                            ])];
                    case 1:
                        _a = _b.sent(), privacyPageRes = _a[0], termsPageRes = _a[1];
                        if (typeof privacyPageRes === 'string' ||
                            typeof termsPageRes === 'string') {
                            throw new Error('Failed to fetch pages');
                        }
                        privacyPage = privacyPageRes;
                        termsPage = termsPageRes;
                        consents = [
                            {
                                consentId: 337,
                                name: ConsentName.PRIVACY_COOKIE_POLICY,
                                version: privacyPage.version,
                                isMandatory: true,
                                consented: null,
                                consentContents: [
                                    {
                                        languageAlpha2Code: lang,
                                        header: privacyPage.description,
                                        content: 'That my personal data will be processed according to the <a class="link" href="/en/?modal=%2Fen%2Ftnc%2Fprivacy-and-cookie-policy">privacy and cookie policy</a> by Gaming Group plc, as data controller.\nConveniently deploy holistic vortals whereas competitive results. Quickly administrate business customer service without maintainable solutions. Compellingly innovate.',
                                    },
                                ],
                            },
                            {
                                consentId: 348,
                                name: ConsentName.TERMS,
                                version: termsPage.version,
                                isMandatory: true,
                                consented: null,
                                consentContents: [
                                    {
                                        languageAlpha2Code: lang,
                                        header: termsPage.description,
                                        content: 'THIS IS A SMALL SUMMARY V225',
                                    },
                                ],
                            },
                        ];
                        return [4 /*yield*/, getFeatureEnabled(Feature.PROMOTIONAL_OFFERS_SIGNUP)];
                    case 2:
                        isPromotionalOffersEnabled = _b.sent();
                        if (isPromotionalOffersEnabled) {
                            consents.push({
                                consentId: 2561,
                                name: ConsentName.PROMOTIONAL_OFFERS,
                                version: '1',
                                isMandatory: false,
                                consented: null,
                                consentContents: [
                                    {
                                        languageAlpha2Code: lang,
                                        header: '',
                                        content: '',
                                    },
                                ],
                            });
                        }
                        return [2 /*return*/, consents.map(function (consent) { return (__assign(__assign({}, consent), { consented: consent.consented || false, consentContents: consent.consentContents.find(function (_a) {
                                    var languageAlpha2Code = _a.languageAlpha2Code;
                                    return languageAlpha2Code === lang;
                                }) })); })];
                }
            });
        });
    };
    SignUpConsentsComponent.prototype.triggerValidationOnNextStep = function () {
        if (!this.nextStepBlocked) {
            return;
        }
        this.touchConsents();
    };
    SignUpConsentsComponent.prototype.markMergedConsentsAsTouched = function () {
        var _this = this;
        this.termsConsents.forEach(function (consent) {
            _this.markConsentAsTouched(consent);
        });
    };
    SignUpConsentsComponent.prototype.toggleTermsGroup = function () {
        this.touchConsents();
        this.toggleGroup(this.termsConsents, this.termsGroupState);
    };
    SignUpConsentsComponent.prototype.touchConsents = function () {
        var _this = this;
        this.termsConsents.forEach(function (consent) {
            _this.consentTouched[consent.consentId] = true;
        });
    };
    SignUpConsentsComponent.prototype.toggleGroup = function (consents, groupState) {
        var toggledState = groupState !== EGroupCheckboxState.CHECKED;
        var modelChanges = consents.reduce(function (acc, consent) {
            var _a;
            return __assign(__assign({}, acc), (_a = {}, _a[consent.consentId] = toggledState, _a));
        }, {});
        this.reconciliateModel(modelChanges);
    };
    SignUpConsentsComponent.prototype.addToGroupedConsent = function (consentGroups, consentGroup, consent, prepend) {
        if (prepend === void 0) { prepend = false; }
        if (consentGroups.hasOwnProperty(consentGroup)) {
            prepend
                ? consentGroups[consentGroup].unshift(consent)
                : consentGroups[consentGroup].push(consent);
        }
        else {
            consentGroups[consentGroup] = [consent];
        }
    };
    SignUpConsentsComponent.prototype.splitTermsAndMarketingConsents = function (consents) {
        var _this = this;
        var consentGroups = {};
        consents
            .filter(function (consent) { return !!consent.consentContents; })
            .forEach(function (consent) {
            var consentGroup = getConsentGroup(consent.name);
            var consentContent = consent;
            if (consent.name === ConsentName.TERMS) {
                consentContent = interpolateConsent(consent, 'minimumAge', MINIMUM_AGE);
                _this.addToGroupedConsent(consentGroups, consentGroup, consentContent, true);
            }
            else {
                _this.addToGroupedConsent(consentGroups, consentGroup, consentContent);
            }
        });
        return consentGroups;
    };
    SignUpConsentsComponent.prototype.onChildrenChange = function (event, consent) {
        var _a;
        var checked = event.detail[0];
        this.reconciliateModel((_a = {}, _a[consent.consentId] = checked, _a));
    };
    SignUpConsentsComponent.prototype.reconciliateModel = function (changes) {
        // create a clone of the field value
        var modelClone = JSON.parse(JSON.stringify(this.valueObject));
        // merges in the changes
        var modelChanges = modelClone.map(function (consent) {
            if (changes.hasOwnProperty(consent.consentId)) {
                return __assign(__assign({}, consent), { consented: changes[consent.consentId] });
            }
            return consent;
        });
        // emit the change
        this.emitStandAloneChange(modelChanges, true);
    };
    SignUpConsentsComponent.prototype.hasErrorConsents = function (consent) {
        return (this.consentTouched[consent.consentId] &&
            consent.isMandatory &&
            !consent.consented);
    };
    SignUpConsentsComponent.prototype.markConsentAsTouched = function (consent) {
        this.consentTouched[consent.consentId] = true;
    };
    SignUpConsentsComponent.prototype.areConsentsValid = function (consents) {
        return !consents.find(function (consent) { return consent.isMandatory && !consent.consented; });
    };
    SignUpConsentsComponent.prototype.emitStandAloneChange = function (value, touched) {
        return {
            value: value,
            isValid: this.areConsentsValid(value),
            touched: touched,
        };
    };
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], SignUpConsentsComponent.prototype, "collapsibleMarketingPreferences", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], SignUpConsentsComponent.prototype, "nextStepBlocked", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], SignUpConsentsComponent.prototype, "valueObject", void 0);
    __decorate([
        FeatureEnabledV2({ slug: Feature.REGISTRATION_MERGED_TERMS }),
        __metadata("design:type", Boolean)
    ], SignUpConsentsComponent.prototype, "isRegistrationMergedTermsEnabled", void 0);
    __decorate([
        signUpModule.Getter('formModel'),
        __metadata("design:type", void 0)
    ], SignUpConsentsComponent.prototype, "formModel", void 0);
    __decorate([
        Watch('nextStepBlocked', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SignUpConsentsComponent.prototype, "triggerValidationOnNextStep", null);
    __decorate([
        Emit('stand-alone-change'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, Boolean]),
        __metadata("design:returntype", void 0)
    ], SignUpConsentsComponent.prototype, "emitStandAloneChange", null);
    SignUpConsentsComponent = __decorate([
        Component({
            name: 'corex-sign-up-consents',
            store: store,
        })
    ], SignUpConsentsComponent);
    return SignUpConsentsComponent;
}(Mixins(MagicConfigMixin)));

export default SignUpConsentsComponent;
